import { useCallback, useEffect, useState } from "react";
import { apiClient } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { RefreshCw, ShieldCheck } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export const useHumanCheck = () => {
  const [challenge, setChallenge] = useState(null);
  const [answer, setAnswer] = useState("");
  const [trap, setTrap] = useState("");
  const refresh = useCallback(() => {
    setAnswer("");
    apiClient.get("/human-check").then((r) => setChallenge(r.data)).catch(() => setChallenge(null));
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const { t } = useI18n();
  const fields = { human_token: challenge?.token, human_answer: answer, website: trap };
  const errorText = (detail) => (typeof detail === "string" && detail.startsWith("Human verification failed") ? t("human.failed") : detail);
  return { challenge, answer, setAnswer, trap, setTrap, refresh, fields, errorText };
};

const questionText = (q, t) => {
  const [a, b] = (q || "").match(/\d+/g) || [];
  return a && b ? t("human.question").replace("{a}", a).replace("{b}", b) : t("human.loading");
};

export const HumanCheck = ({ check, idPrefix }) => {
  const { t } = useI18n();
  return (
  <div className="rounded-md border border-slate-200 bg-slate-50 p-3" data-testid={`${idPrefix}-human-check`}>
    <div className="flex items-center gap-2 text-xs font-semibold text-slate-700">
      <ShieldCheck size={14} className="text-emerald-600" />
      <span data-testid={`${idPrefix}-human-question`}>{questionText(check.challenge?.question, t)}</span>
      <button type="button" onClick={check.refresh} className="ml-auto text-slate-500 hover:text-slate-900" aria-label={t("human.refresh")} data-testid={`${idPrefix}-human-refresh`}>
        <RefreshCw size={12} />
      </button>
    </div>
    <Input
      className="mt-2 bg-white"
      inputMode="numeric"
      required
      placeholder={t("human.placeholder")}
      value={check.answer}
      onChange={(e) => check.setAnswer(e.target.value)}
      data-testid={`${idPrefix}-human-answer`}
    />
    <input
      type="text"
      name="website"
      tabIndex={-1}
      autoComplete="off"
      aria-hidden="true"
      value={check.trap}
      onChange={(e) => check.setTrap(e.target.value)}
      style={{ position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0 }}
    />
  </div>
);
};
